module.exports = __webpack_public_path__ + "img/smalltick.80e23a5b.svg";